import React, { createContext, useContext, useEffect, useState } from "react";
import { api, getDownloadToken, clearDownloadToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const check = async () => {
      try {
        const r = await api.get("/auth/me");
        setUser(r.data);
        getDownloadToken();
      } catch {
        // Not authenticated — clean up any legacy token
        localStorage.removeItem("archivio_token");
      } finally {
        setLoading(false);
      }
    };
    check();
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    // Auth is now carried by httpOnly cookie set by the backend.
    // Remove any legacy localStorage token to prevent XSS token theft.
    localStorage.removeItem("archivio_token");
    setUser(r.data.user);
    getDownloadToken();
    return r.data.user;
  };

  const register = async (name, email, password) => {
    const r = await api.post("/auth/register", { name, email, password });
    localStorage.removeItem("archivio_token");
    setUser(r.data.user);
    getDownloadToken();
    return r.data.user;
  };

  const setUserFromGoogle = (u) => {
    setUser(u);
    getDownloadToken();
  };

  const logout = async () => {
    try { await api.post("/auth/logout", null); }
    catch (err) { console.warn("logout", err); }
    localStorage.removeItem("archivio_token");
    clearDownloadToken();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setUserFromGoogle }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
